// https://bdwm.be/javascript-one-pager-navigation-with-intersectionobserver/
export const observeVertical = ({nameAttr, setActiveSection, rootMargin}) => {
    const options = {
        root: null,
        threshold: 0,
        rootMargin,
    }
    const observer = new IntersectionObserver( changeNav, options)
    return observer


    function changeNav(entries, observer) {
        let activeBlock = null // the block that should be highlighted in the menu.
        let skip = false
        for (const entry of entries) {
            skip = false

            if(!entry.isIntersecting) {
              
                // This element has just left the viewport. This means at least one of 2 possibilities:
                // 1. the next element has its top aligned with the top of the viewport.
                //    In this case the next element should be activated.
                // 2. the previous element is (at least partly) visible.
                //    In this case we need to keep looking at previous elements until
                //    we find the highest one that is still visible.
              
                if (isInViewport(entry.target.nextElementSibling)) {
                    // possibility 1.
                    activeBlock = entry.target.nextElementSibling;
                } else if (isInViewport(entry.target.previousElementSibling)) {
                    // possibility 2.
                    activeBlock = entry.target.previousElementSibling;
                    while ( isInViewport(activeBlock.previousElementSibling) ) {
                      activeBlock = activeBlock.previousElementSibling;
                    }
                }
            } else {

                // This element just entered the viewport. 2 possibilities:
                // 1. The top of the element moved in from the bottom.
                //    In this case nothing needs to happen.
                // 2. The bottom of the element moved in from the top.
                //    In this case the current element should also become active.

                if (!isInViewport(entry.target.previousElementSibling)) {
                    // possibility 2.
                    activeBlock = entry.target;
                } else if (!isInViewport(entry.target.nextElementSibling)) {
                    skip = true
                    continue
                }
            }

            if (activeBlock) {
                break
            }
        } // for of
//console.log('changeNav', entries, skip, activeBlock)
        if (!skip) {
            const name = activeBlock ? activeBlock.getAttribute(nameAttr) : ''
            setActiveSection(name)
        }
    } //changeNav

}

function isInViewport(element) {
    if (!element) {
      return false;
    }
    const rect = element.getBoundingClientRect()
    return (
        rect.bottom >= 0 &&
        rect.top <= window.innerHeight
    )
}
